import BotControls from 'Components/AppComponents/Bot/BotControls';
import WindTurbine from 'Components/AppComponents/WindTurbine/WindTurbine';
import BoardLayout from '../BoardLayout';
import { Client } from 'boardgame.io/react';
import { Local } from 'boardgame.io/multiplayer';
import { PGP } from 'Components/AppComponents/Game/Game';
import { Board } from 'StateContainer';
import { GameHelper } from 'Helpers/GameHelper';
import LoadingBar from 'Components/AppComponents/LoadingBar/LoadingBar';
import 'Components/AppComponents/Board/BoardContainer/BoardContainer.css';

const StateContainer = Client({ game: PGP, board: Board, numPlayers: 2, debug: false, multiplayer: Local() });

function BoardContainer() {
    // const [showOverlay, setShowOverlay] = useState(false);
    return (
        <div id="board-container" className="relative m-auto duration-1000 blur-full-on">
            
            <BoardLayout>
                {/* left side */}
                <>
                    {/* Humans */}
                    <img src="images/Character-03.png" alt="character" style={{ width: '59px', top: '43%', left: '34%' }} />
                    <img src="images/Character-01.png" alt="character" style={{ width: '52px', top: '47%', left: '39%' }} />
                    <img src="images/Character-02.png" alt="character" style={{ width: '59px', top: '76%', left: '8%', zIndex: 10 }} />

                    {/* Clouds */}
                    <img src="/images/Cloud01.png" alt="cloud" className="cloud" style={{ top: '47%', left: '2%', width: '120px', animation: `cloud-animation ${GameHelper.randomGenerator(70, 75)}s infinite ease-in-out` }} />
                    <img src="/images/Cloud03.png" alt="cloud" className="cloud" style={{ top: '17%', left: '14%', width: '120px', animation: `cloud-animation ${GameHelper.randomGenerator(70, 75)}s infinite ease-in-out` }} />
                    <img src="/images/Cloud02.png" alt="cloud" className="cloud" style={{ top: '57%', left: '35%', width: '75px', animation: `cloud-animation ${GameHelper.randomGenerator(70, 75)}s infinite ease-in-out` }} />

                    {/* mountains */}
                    <img src="/images/LeftMountains.png" alt="left-mountain" className="left-mountains" style={{ top: '25%', left: '4%', width: '200px' }} />

                    {/* City */}
                    <img src="/images/LeftCity.png" alt="city" className="" style={{ top: '63%', left: '24%', width: '285px' }} />

                    {/* Villages */}
                    <img src="/images/LeftVillage01.png" alt="village" className="" style={{ top: '21%', left: '24%', width: '265px' }} />
                    <img src="/images/LeftVillage02.png" alt="village" className="" style={{ top: '59%', left: '2%', width: '255px' }} />

                    {/* Left solar panels and turbines */}
                    <>
                        {/* Solar panels */}
                        <img src="/images/LeftSolarPanels.png" alt="solar-panels" className="" style={{ top: '25%', left: '4%', width: '220px' }} />

                        {/* AI side of turbine */}
                        <WindTurbine containerStyles={{ top: '30.5%', left: '7.5%' }} poleStyles={{ height: '45px' }} />
                        <WindTurbine containerStyles={{ top: '30.5%', left: '10%' }} poleStyles={{ height: '23px' }} />
                        <WindTurbine containerStyles={{ top: '30.5%', left: '12.5%' }} poleStyles={{ height: '23px' }} />
                        <WindTurbine containerStyles={{ top: '30.5%', left: '15%' }} poleStyles={{ height: '23px' }} />
                    </>
                </>

                {/* Right side */}
                <>
                    {/* Humans */}
                    <img src="images/Character-05.png" alt="character" style={{ width: '58px', top: '34%', left: '53%', zIndex: 10 }} />
                    <img src="images/Character-04.png" alt="character" style={{ width: '81px', top: '78%', left: '58%', zIndex: 10 }} />

                    {/* Clouds */}
                    <img src="/images/Cloud05.png" alt="cloud" className="cloud" style={{ top: '21%', left: '77%', width: '125px', animation: `cloud-animation ${GameHelper.randomGenerator(75, 80)}s infinite ease-in-out` }} />
                    <img src="/images/Cloud05.png" alt="cloud" className="cloud" style={{ top: '44%', left: '78%', width: '120px', animation: `cloud-animation ${GameHelper.randomGenerator(75, 80)}s infinite ease-in-out` }} />

                    {/* mountains */}
                    <img src="/images/RightMountains.png" alt="right-mountain" className="" style={{ top: '25%', left: '77%', width: '220px' }} />

                    {/* City */}
                    <img src="/images/RightCity.png" alt="city" className="" style={{ top: '22%', left: '51%', width: '275px' }} />

                    {/* Villages */}
                    <img src="/images/RightVillage01.png" alt="village" className="" style={{ top: '64%', left: '51%', width: '255px' }} />
                    <img src="/images/RightVillage02.png" alt="village" className="" style={{ top: '55%', left: '76%', width: '235px' }} />

                    {/* Water */}
                    <img src="/images/deep-water.png" alt="water" className="bottom-0 right-0" style={{ animation: `deep-water-animation 5s infinite ease-in` }} />
                    <img src="/images/Water01.png" alt="water" className="" style={{ top: '82%', left: '76%', width: '235px', animation: `water-animation-1 ${GameHelper.randomGenerator(75, 80)}s infinite ease-in-out` }} />
                    <img src="/images/Water02.png" alt="water" className="" style={{ top: '80%', left: '76%', width: '235px', animation: `water-animation-2 ${GameHelper.randomGenerator(75, 80)}s infinite ease-in-out` }} />
                    <img src="/images/Water03.png" alt="water" className="" style={{ top: '87%', left: '76%', width: '235px', animation: `water-animation-3 ${GameHelper.randomGenerator(75, 80)}s infinite ease-in-out` }} />

                    {/* Right solar panels and turbines */}
                    <>
                        {/* Solar panels */}
                        <img src="/images/RightSolarPanels.png" alt="solar-panels" className="" style={{ top: '25%', left: '76%', width: '220px' }} />

                        {/* Human side of turbines */}
                        <WindTurbine containerStyles={{ top: '33.5%', left: '79.3%' }} poleStyles={{ height: '12px' }} />
                        <WindTurbine containerStyles={{ top: '33.5%', left: '81.62%' }} poleStyles={{ height: '12px' }} />
                        <WindTurbine containerStyles={{ top: '33.5%', left: '83.94%' }} poleStyles={{ height: '12px' }} />
                        <WindTurbine containerStyles={{ top: '33.5%', left: '86.3%' }} poleStyles={{ height: '19px' }} />
                        <WindTurbine containerStyles={{ top: '33.5%', left: '88.7%' }} poleStyles={{ height: '30px' }} />
                        <WindTurbine containerStyles={{ top: '33.5%', left: '91%' }} poleStyles={{ height: '28px' }} />
                    </>
                </>

                <img src="images/BoardText.png" alt="board text" style={{ width: '46px', top: '29%', right: '1.5%' }} />
            </BoardLayout>

            <StateContainer playerID="0" matchID="single-vs-ai" />
            <BotControls playerID="1" matchID="single-vs-ai" />
            <LoadingBar />
        </div>
    );
}

export default BoardContainer;
